(function () {
  'use strict';

  // These read the data PHP localizes as `window.custom` (see
  // enqueues.php: wp_add_inline_script('custom', 'var custom = {...}')).
  // They were previously referenced as bare globals (crmType,
  // smsDisclaimer) that were never actually declared anywhere, which threw
  // a ReferenceError on every page load and silently aborted the rest of
  // init() — including any initializer listed after initActionNetwork().
  var customData = (typeof window !== 'undefined' && window.custom) || {};
  var crmType = customData.crm || '';
  var smsDisclaimer = customData.disclaimer || '';

  // Small helpers used throughout this file; also previously missing.
  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }
  function qsa(sel, ctx) {
    return Array.from((ctx || document).querySelectorAll(sel));
  }
  function onDocumentEvent(name, cb) {
    document.addEventListener(name, cb);
  }

  // mobile nav
  function initMobileNav() {
    var toggle = document.querySelector('.header__mobile-toggle');
    var nav = document.querySelector('.nav');
    if (!toggle || !nav) return;

    var subToggles = nav.querySelectorAll('.nav__sub-toggle');

    function closeAllSubmenus() {
      nav.querySelectorAll('.nav__item.is-open').forEach(function (item) {
        item.classList.remove('is-open');
      });
      subToggles.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    function closeMobileNav() {
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      closeAllSubmenus();
    }

    // top-level hamburger toggle
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';

      if (expanded) {
        closeMobileNav();
      } else {
        toggle.setAttribute('aria-expanded', 'true');
        nav.classList.add('is-open');
      }
    });

    // child-menu (submenu) toggles
    subToggles.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();

        var item = btn.closest('.nav__item');
        if (!item) return;

        var isOpen = item.classList.contains('is-open');

        // collapse sibling submenus at the same level first
        var siblings = item.parentElement ? item.parentElement.children : [];
        for (var i = 0; i < siblings.length; i++) {
          if (siblings[i] !== item) {
            siblings[i].classList.remove('is-open');
            var siblingToggle = siblings[i].querySelector(':scope > .nav__sub-toggle');
            if (siblingToggle) siblingToggle.setAttribute('aria-expanded', 'false');
          }
        }

        item.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    // clicking outside the mobile nav closes it
    document.addEventListener('click', function (e) {
      if (window.matchMedia('(min-width: 768px)').matches) return;
      if (!nav.classList.contains('is-open')) return;
      if (nav.contains(e.target) || toggle.contains(e.target)) return;

      closeMobileNav();
    });

    // Escape closes everything
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;

      if (window.matchMedia('(min-width: 768px)').matches) {
        closeAllSubmenus();
      } else if (nav.classList.contains('is-open')) {
        closeMobileNav();
      }
    });
  }

  // action network
	const PAIR_STACK_QUERY = '(max-width: 600px)';
	const PAIR_GAP = 6; // px
	const PAIR_EMAIL_WIDTH = 60; // %

	// Every pair discovered so far, so the breakpoint listener can re-apply.
	const pairs = [];

	const isHidden = (el) => {
		if (el.hidden) {
			return true;
		}
		const style = getComputedStyle(el);
		// `display` is not inherited, so a child of a display:none popup still
		// reports its own value here.
		return style.display === 'none';
	};

	const nextVisible = (el) => {
		let sib = el.nextElementSibling;
		while (sib && isHidden(sib)) {
			sib = sib.nextElementSibling;
		}
		return sib;
	};

	/**
	 * Given two inputs, walk up both ancestor chains to find the pair of
	 * elements that are siblings of one another — i.e. the "row" wrappers,
	 * whatever tag Action Network happens to be using.
	 *
	 * This is the part the CSS :has() version got wrong: it assumed the rows
	 * were <li> elements directly inside a <ul>.
	 */
	function findSiblingRows(a, b, boundary) {
		const chainA = [];
		for (let el = a; el && el !== boundary; el = el.parentElement) {
			chainA.push(el);
		}

		for (let elB = b; elB && elB !== boundary; elB = elB.parentElement) {
			const parent = elB.parentElement;
			if (!parent) {
				break;
			}

			const elA = chainA.find((x) => x.parentElement === parent && x !== elB);
			if (elA) {
				return { container: parent, rowA: elA, rowB: elB };
			}
		}

		return null;
	}

	/**
	 * Widths are set inline with `important` priority because Action Network's
	 * own stylesheet loads after the theme's and is aggressive about form
	 * layout. Inline + important is the only declaration that reliably wins.
	 */
	function applyPairLayout() {
		const stack = window.matchMedia(PAIR_STACK_QUERY).matches;
		const half = PAIR_GAP / 2;

		pairs.forEach((pair) => {
			const { container, emailRow, zipRow } = pair;

			if (!container.isConnected) {
				return;
			}

			if (stack) {
				['display', 'flex-wrap', 'column-gap'].forEach((prop) =>
					container.style.removeProperty(prop)
				);
				Array.from(container.children).forEach((child) =>
					child.style.removeProperty('flex')
				);
				return;
			}

			container.style.setProperty('display', 'flex', 'important');
			container.style.setProperty('flex-wrap', 'wrap', 'important');
			container.style.setProperty('column-gap', PAIR_GAP + 'px', 'important');

			// Everything that is not part of the pair keeps stacking.
			Array.from(container.children).forEach((child) => {
				if (child !== emailRow && child !== zipRow) {
					child.style.setProperty('flex', '0 0 100%', 'important');
				}
			});

			emailRow.style.setProperty(
				'flex',
				'0 0 calc(' + PAIR_EMAIL_WIDTH + '% - ' + half + 'px)',
				'important'
			);
			zipRow.style.setProperty(
				'flex',
				'0 0 calc(' + (100 - PAIR_EMAIL_WIDTH) + '% - ' + half + 'px)',
				'important'
			);

			// The inputs themselves need to fill their new row width.
			[pair.email, pair.zip].forEach((input) => {
				input.style.setProperty('width', '100%', 'important');
				input.style.setProperty('box-sizing', 'border-box', 'important');
			});
		});
	}

	function pairEmailAndZip() {
		// Attribute selectors rather than #id: Action Network emits duplicate
		// IDs when more than one form is embedded on the same page.
		qsa('input[id="form-email"]').forEach((email) => {
			const scope = email.closest('form') ||
				email.closest('.can_embed') ||
				email.closest('#can_embed_form');

			if (!scope) {
				return;
			}

			const zip = scope.querySelector('input[id="form-zip_code"]');
			if (!zip || zip === email) {
				return;
			}

			// Already handled on a previous pass.
			if (pairs.some((p) => p.email === email)) {
				return;
			}

			const rows = findSiblingRows(email, zip, scope.parentElement);
			if (!rows) {
				return;
			}

			const emailRow = rows.rowA.contains(email) ? rows.rowA : rows.rowB;
			const zipRow = emailRow === rows.rowA ? rows.rowB : rows.rowA;

			// Only pair them if they are visually adjacent, ignoring any
			// hidden fields Action Network leaves in the markup.
			if (nextVisible(emailRow) !== zipRow && nextVisible(zipRow) !== emailRow) {
				return;
			}

			rows.container.classList.add('an-pair');
			emailRow.classList.add('an-pair__email');
			zipRow.classList.add('an-pair__zip');

			pairs.push({
				container: rows.container,
				emailRow: emailRow,
				zipRow: zipRow,
				email: email,
				zip: zip,
			});
		});

		applyPairLayout();
	}

	/**
	 * Action Network re-renders the form on validation errors without firing
	 * another web-*_loaded event, so watch for it rather than chasing event
	 * names.
	 */
	function watchActionNetworkForms() {
		if (typeof MutationObserver === 'undefined') {
			return;
		}

		const roots = qsa('#can_embed_form, .can_embed');
		if (!roots.length) {
			return;
		}

		let pending;
		const observer = new MutationObserver(() => {
			clearTimeout(pending);
			pending = setTimeout(() => {
				// Drop any pairs whose nodes have been replaced.
				for (let i = pairs.length - 1; i >= 0; i--) {
					if (!pairs[i].email.isConnected) {
						pairs.splice(i, 1);
					}
				}
				pairEmailAndZip();
			}, 100);
		});

		roots.forEach((root) =>
			observer.observe(root, { childList: true, subtree: true })
		);
	}

	// ---------------------------------------------------------------------
	// Action Network embedded form cleanup
	// ---------------------------------------------------------------------

	const AN_PLACEHOLDERS = {
		'input#form-email': 'Email Address*',
		'input#form-zip_code': 'Zip Code*',
		'input#form-phone': 'Mobile Number',
	};

	const AN_REMOVE = [
		'#can_embed_form_inner > h2',
		'#can_embed_form_inner > h3',
		'#can_embed_form_inner > h4',
		'li.form_builder_output',
		'#action_info',
		'#logo_wrap',
		'span.international_link-wrap',
	];

	/**
	 * Was duplicated verbatim five times in the previous version.
	 * @param {{removeCountryDrop?: boolean}} [options]
	 */
	function patchActionNetworkForm(options) {
		const opts = options || {};

		AN_REMOVE.forEach((sel) => qsa(sel).forEach((el) => el.remove()));

		if (opts.removeCountryDrop) {
			qsa('span.country_drop_wrap').forEach((el) => el.remove());
		}

		Object.keys(AN_PLACEHOLDERS).forEach((sel) => {
			const input = qs(sel);
			if (input) {
				input.placeholder = AN_PLACEHOLDERS[sel];
			}
		});

		const smsGroup = qs('input[name="subscription[sms_group]"]');
		if (smsGroup) {
			smsGroup.checked = true;
		}

		if (smsDisclaimer) {
			const target = qs('#mobile_opt_in_default');
			if (target) {
				target.innerHTML = smsDisclaimer;
			}
		}

		// jQuery's .css() cannot set !important, so the original line silently
		// did nothing. setProperty() takes the priority as a third argument.
		const zip = qs('#can_embed_form .core_field #form-zip_code:not(.mb_needed)');
		if (zip) {
			zip.style.setProperty('margin-bottom', '6px', 'important');
		}

		// Runs last: the removals above change sibling order, and adjacency is
		// what decides whether the pair gets applied.
		pairEmailAndZip();
		watchActionNetworkForms();
	}

	function initActionNetwork() {
		if (crmType !== 'action-network') {
			return;
		}

		['web-popup_loaded', 'web-featured_loaded', 'web-ad_loaded', 'web-footer-cta_loaded']
			.forEach((name) => onDocumentEvent(name, () => patchActionNetworkForm()));

		onDocumentEvent('web-splash_loaded', () =>
			patchActionNetworkForm({ removeCountryDrop: true })
		);

		const mq = window.matchMedia(PAIR_STACK_QUERY);
		if (mq.addEventListener) {
			mq.addEventListener('change', applyPairLayout);
		} else if (mq.addListener) {
			mq.addListener(applyPairLayout);
		}
	}

  // candidate filter: plain GET form fields still get added to the query
  // string even when empty (e.g. "class=" for the level-only search from
  // the endorsements block). Disabling empty fields right before submit
  // removes them from the request, since disabled controls aren't sent.
  function initCandidateFilter() {
    const form = document.getElementById('candidate-filter');
    if (!form) return;

    form.addEventListener('submit', function () {
      form.querySelectorAll('select, input').forEach(function (field) {
        field.disabled = !field.value;
      });
    });

    // if the page is restored from the back/forward cache after a submit,
    // make sure nothing is left disabled
    window.addEventListener('pageshow', function () {
      form.querySelectorAll('select, input').forEach(function (field) {
        field.disabled = false;
      });
    });
  }

  function init() {
    var initializers = [initMobileNav, initActionNetwork, initCandidateFilter];

    initializers.forEach(function (fn) {
      try {
        fn();
      } catch (err) {
        // one broken initializer should never stop the others from running
        console.error('[custom.js] ' + fn.name + ' failed:', err);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
